'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useQuery } from '@tanstack/react-query';
import { LoaderCircle } from 'lucide-react';
import { useMemo, useState } from 'react';
import { getAllNotifications } from '@/actions/notification';
import { NotificationMarkAllButton } from '@/components/notifications/notification-mark-all-button';
import NotificationsList from '@/components/notifications/notifications-list';
import { NotificationsUnreadSwitch } from '@/components/notifications/notifications-unread-switch';
import { mapApiNotificationToItem } from '@/lib/notifications';
import type { NotificationsList as NotificationsListType } from '@/types/notifications';

export default function NotificationsWrapper() {
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);

  const { data, isLoading } = useQuery({
    queryKey: ['notifications'],
    queryFn: () => getAllNotifications('in-app'),
    refetchOnWindowFocus: true,
  });

  const notificationsList: NotificationsListType = useMemo(() => {
    if (!data?.data) return [];
    return data.data.map(mapApiNotificationToItem);
  }, [data?.data]);

  const hasUnread = useMemo(() => notificationsList.some((n) => !n.read), [notificationsList]);

  const filteredNotifications = useMemo(
    () =>
      showUnreadOnly
        ? notificationsList.filter((notification) => !notification.read)
        : notificationsList,
    [notificationsList, showUnreadOnly]
  );

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-center lg:gap-3">
        <h3 className="text-primary text-base font-medium dark:text-neutral-100">
          {'Notifications'}
        </h3>

        <hr className="border-grey-100 dark:border-grey-800 block w-full lg:hidden" />

        <div className="flex w-full items-center justify-between gap-6 lg:justify-end">
          <NotificationsUnreadSwitch
            value={showUnreadOnly}
            onChange={setShowUnreadOnly}
            hasUnread={hasUnread}
          />

          <NotificationMarkAllButton disabled={!hasUnread} />
        </div>
      </div>

      <hr className="border-grey-200 dark:border-grey-800 hidden lg:block" />

      {isLoading ? (
        <div className="flex items-center justify-center py-8">
          <LoaderCircle className="h-8 w-8 animate-spin text-pink-400" />
        </div>
      ) : (
        <NotificationsList notificationsList={filteredNotifications} />
      )}
    </div>
  );
}
